export default __webpack_public_path__ + "static/process1-1c91d30351f611ba941cd0745d2a1e3b.png";